var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"intro"}},[_c('home-slider',{attrs:{"error":_vm.error,"show":_vm.show,"data":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }